import PropTypes from 'prop-types';

import { Input, InputGroup } from 'components/FormComponents';

export const NumberInput = ({
  name,
  placeholder,
  disabled,
  register = () => {},
  validators = {},
  className,
  defaultValue,
  min,
  max,
  step,
  inputProps = {},
  error = '',
  noErrorMessage = false,
  noMargin = false,
}) => {
  return (
    <InputGroup noMargin={noMargin}>
      <Input
        name={name}
        type="number"
        placeholder={placeholder}
        disabled={disabled}
        className={className}
        defaultValue={defaultValue}
        min={min}
        max={max}
        step={step}
        register={register}
        validators={validators}
        error={error}
        noErrorMessage={noErrorMessage}
        noPadding
        {...inputProps}
      />
    </InputGroup>
  );
};

NumberInput.propTypes = {
  name: PropTypes.string,
  placeholder: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  defaultValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  disabled: PropTypes.bool,
  min: PropTypes.number,
  max: PropTypes.number,
  /** e.g. 1 for integers, 0.01 for 2 decimal places */
  step: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  className: PropTypes.string,
  register: PropTypes.func,
  inputProps: PropTypes.object,
  error: PropTypes.string,
  noErrorMessage: PropTypes.bool,
  noMargin: PropTypes.bool,
};
